import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import excellentKnowledgeEsPNG from '~/assets/images/history/history-excellent-knowledge-es.png'
import excellentKnowledgeEsWEBP from '~/assets/images/history/history-excellent-knowledge-es.webp'
import excellentKnowledgePtPNG from '~/assets/images/history/history-excellent-knowledge-pt.png'
import excellentKnowledgePtWEBP from '~/assets/images/history/history-excellent-knowledge-pt.webp'
import excellentKnowledgePNG from '~/assets/images/history/history-excellent-knowledge.png'
import excellentKnowledgeWEBP from '~/assets/images/history/history-excellent-knowledge.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectLanguage } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const LOCALE_IMAGE_MAP: Record<string, { png: string; webp: string }> = {
  es: { png: excellentKnowledgeEsPNG, webp: excellentKnowledgeEsWEBP },
  pt: { png: excellentKnowledgePtPNG, webp: excellentKnowledgePtWEBP },
  en: { png: excellentKnowledgePNG, webp: excellentKnowledgeWEBP },
}

const ExcellentKnowledgeHistory = ({ nextPagePath, pageId }: TPageProps) => {
  const lang = useSelector(selectLanguage)
  const { png, webp } = LOCALE_IMAGE_MAP[lang] ?? LOCALE_IMAGE_MAP.en

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Excellent knowledge',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={webp} type="image/webp" />
            <img src={png} alt="Excellent knowledge" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans
            ns="history"
            i18nKey="onboarding.historyExcellentKnowledge.title"
          />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="history"
            i18nKey="onboarding.historyExcellentKnowledge.subtitle"
          />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default ExcellentKnowledgeHistory
